import { PaginateListMore } from '../../../common/types/common-types';
import { apiClient, apiErrorHandler } from 'src/app/common/network';
import { Dispatch } from 'react';
import { LifeStyleSurveyDetailReportListParams } from '../types/candidateLifeStyleSurveyDetailReportTypes';

const ADMIN_URL = `${window.envConfig['REACT_APP_APIM_BASE_URL']}${window.envConfig['REACT_APP_APIM_ADMIN']}`;

export const fetchCandidateLifeStyleSurveyDetailDownload = (
  params: LifeStyleSurveyDetailReportListParams,
  dispatch?: Dispatch<any>,
): void => {
  const uri = `${ADMIN_URL}/report/candidate/life-style-survey-detail/export`;

  apiClient
    .post<Blob>(uri, { ...params }, { responseType: 'text' })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob(['\uFEFF' + response.data], { type: 'text/csv;charset=utf-8;' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'report-lifeStyle-survey-detail' + new Date().toISOString() + '.csv');
      document.body.appendChild(link);
      link.click();
    })
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const fetchCandidateLifeStyleSurveyDetail = async (
  params: LifeStyleSurveyDetailReportListParams,
  dispatch?: Dispatch<any>,
): Promise<PaginateListMore<any>> => {
  const uri = `${ADMIN_URL}/report/candidate/life-style-survey-detail`;

  return apiClient
    .post<PaginateListMore<any>>(uri, { ...params })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};
